import type CharmSuggestionItem from 'owa-calendar-charm-suggestions-store/lib/schema/CharmSuggestionsItem';
import { CharmSelectionType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { dismissCharmSuggestions } from 'owa-calendar-charm-suggestions-store/lib/actions/charmSuggestionActions';
import { orchestrator } from 'satcheljs';
import {
    onCharmAndSelectionTypeChanged,
    updateSubject,
    onCharmSuggestionChanged,
} from 'owa-calendar-compose-form-actions';

/**
 * Updates compose store when the charm has changed from the charm suggestions callout
 */
export default orchestrator(onCharmSuggestionChanged, actionMessage => {
    let charmSuggestionsItem: CharmSuggestionItem = actionMessage.charmSuggestionItem;
    onCharmAndSelectionTypeChanged(charmSuggestionsItem.charm, CharmSelectionType.Suggestion);
    updateSubject(charmSuggestionsItem.keyword);
    dismissCharmSuggestions();
});
